<template>
  <div>
    <Input @on-focus="openGroup = true" @on-clear="clear" clearable v-if="isMore" v-model="text" readonly placeholder="请选择"></Input>
    <Input v-else @on-focus="openGroup = true" :value="name" readonly placeholder="请选择"></Input>

    <Drawer :placement="placement" :closable="false" v-model="openGroup" width='450' draggable class="my-drawer">
      <person-tool @person="rePerson" @persons="rePersons" :isMore="isMore"></person-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "isMore"],
  data() {
    return {
      openGroup: false,
      text:''
    };
  },
  methods: {
    rePerson(v) {
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("person", v);
    },
    rePersons(v) {
      var deviceIdList = [];
      for (let i = 0; i < v.length; i++) {

        deviceIdList.push(v[i].deviceId);

      }
      this.text='选择'+deviceIdList.length+'个人'
      this.$emit('deviceIdList', deviceIdList)
    },
    clear() {
     this.rePersons([])
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectPerson.vue